import React from "react";
import { Chip } from "@nivo/tooltip";
import styles from "./extractedFiles.module.scss";
const LinkTooltip = ({ link }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: styles.tooltip },
            React.createElement(Chip, { color: link.source.color, style: { marginRight: "4px" } }),
            React.createElement("strong", null, link.source.label),
            React.createElement("span", null, "\u00A0>\u00A0"),
            React.createElement("strong", null, link.target.label),
            React.createElement(Chip, { color: link.target.color, style: { marginLeft: "4px", marginRight: "4px" } }),
            React.createElement("strong", { className: styles.value }, link.originalValue))));
};
export default LinkTooltip;
//# sourceMappingURL=LinkTooltip.js.map